import { media, styled, typography } from '@pulse-web-ui/theme';

export const WidgetHeader = styled.h2<{ $marginBottom?: number }>`
  ${typography.medium20};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 0}px;

  ${media.desktop} {
    ${typography.medium24};
  }
`;

export const WidgetSubHeaderText = styled.h3<{
  $center?: boolean;
  $marginBottom?: number;
}>`
  ${typography.regular16}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 16}px;
  text-align: ${({ $center }) => ($center ? 'center' : 'inherit')};
  line-height: 24px;
`;

export const PageHeader = styled.h1<{
  $marginBottom?: number;
  $padding?: [number, number];
  $fontSize?: string;
}>`
  ${typography.medium20};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 0}px;
  padding: ${({ $padding }) => $padding?.join('px ') ?? '0 0'}px;

  ${media.desktop} {
    ${({ $fontSize }) => $fontSize ?? typography.medium24};
  }
`;

export const FormControlHeader = styled.h3<{
  $marginBottom?: number;
}>`
  ${typography.medium18};
  margin-bottom: ${({ $marginBottom }) => $marginBottom ?? 12}px;
`;
